import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Input, Button, Modal } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styles from "../../../styles/Components/mini-app/auth/MiniAppLoginPage.module.css";
import { logInValidation } from "../../../utility/Validation/validation";
import { handleBlur } from "../../../utility/action";
import { AuthenticationDetails, CognitoUser } from "amazon-cognito-identity-js";
import { checkEmailException, formatUserData } from "../../../utility/helper";
import PoolData from "../../../pages/Auth/AWSConfig/PoolData";
import {
  setToken,
  setUserData,
  signinUpMiniApp,
} from "../../../redux/main/action/main";
import axios from "axios";
import { notify } from "../../../utility/Toastify/toastify";
import { useDispatch, useSelector } from "react-redux";
import { routeConvertor } from "../../../utility/formatter-helper";
import MiniAppSignupPage from "./MiniAppSignupPage";
import MiniAppConfirmPage from "./MiniAppConfirmPage";
import ConfirmAlert from "../../../pages/Auth/ConfirmAlert";
import MiniAppResendConfirmationCode from "./MiniAppResendConfirmationCode";
import MiniAppOtpLogin from "./MiniAppOtpLogin";
import { FcGoogle } from "react-icons/fc";
import { TfiEmail } from "react-icons/tfi";
import { HiOutlineLockClosed } from "react-icons/hi";
import RecaptchaModal from "../../../pages/Auth/login/RecaptchaModal";

const GoogleButton = ({ onClick }) => {
  return (
    <div className={styles.googleBtn} onClick={onClick}>
      <FcGoogle /> login with Google
    </div>
  );
};

function MiniAppLoginPage({ auth = "" }) {
  const {
    main: { telegramData },
  } = useSelector((state) => state);
  const [authType, setAuthType] = useState(auth || "login");
  const [loading, setLoading] = useState(false);
  const [showConfirmAlert, setShowConfirmAlert] = useState(false);
  const [formData, setFormData] = useState(null);
  const [showRecaptchaModal, setShowRecaptchaModal] = useState(false);

  const [userEmail, setUserEmail] = useState("");
  const [pass, setPass] = useState("");
  const [loginType, setLoginType] = useState("email");

  const [params] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Get the value of the 'telegram_auth' parameter
  const telegramAuth = params.get("tgWebAppStartParam");

  // Get the value of the 'user' parameter
  const telegram_id = telegramData?.telegramId || telegramAuth?.slice(0, 20);
  const telegramId = telegram_id?.replace(/^0+/, "");

  const next = telegramData?.next || telegramAuth?.slice(-5);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(logInValidation),
    mode: "onBlur",
  });

  const navigateHandler = () => {
    navigate(`/${routeConvertor[next] || "mini-portfolio"}`);
  };

  const setAuthData = (data, authType = "cognito") => {
    dispatch(setToken(data?.idToken?.jwtToken));
    dispatch(
      setUserData(
        authType === "cognito"
          ? data?.idToken?.payload
          : formatUserData(data?.accessToken),
      ),
    );
    axios.defaults.headers.common["Authorization"] =
      authType === "cognito"
        ? `Bearer ${data?.idToken?.jwtToken}`
        : `${data?.idToken?.jwtToken}`;

    localStorage.setItem(
      "aws-amplify-federatedInfo",
      JSON.stringify({ token: data?.idToken?.jwtToken }),
    );
    localStorage.setItem(
      "aws-amplify-USERDATA",
      JSON.stringify(data?.idToken?.payload),
    );

    dispatch(
      signinUpMiniApp(
        telegramId,
        data?.idToken?.payload["custom:custom_username"],
        data?.idToken?.payload?.email,
      ),
    );
  };

  const onSubmit = (data) => {
    setFormData(data);
    setShowRecaptchaModal(true);
  };

  return (
    <div className={styles.container}>
      {authType === "login" && loginType === "email" && (
        <h4 className={styles.title}>
          <span>Login</span> <br />
          to Your <br /> Account
        </h4>
      )}

      {authType === "login" && loginType === "email" && (
        <Form onFinish={handleSubmit(onSubmit)}>
          <Form.Item
            label=""
            validateStatus={errors.email ? "error" : ""}
            help={errors.email ? errors.email.message : ""}
            className={styles.formItem}
          >
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <div className={styles.inputWrapper}>
                  <TfiEmail color="#454545" />
                  <Input
                    {...field}
                    type="email"
                    onBlur={(e) => {
                      field.onBlur(e);
                      handleBlur(e);
                    }}
                    placeholder="Email"
                    autoComplete="email"
                  />
                </div>
              )}
            />
          </Form.Item>

          <Form.Item
            label=""
            validateStatus={errors.pass ? "error" : ""}
            help={errors.pass ? errors.pass.message : ""}
            className={styles.formItem}
          >
            <Controller
              name="pass"
              control={control}
              render={({ field }) => (
                <div className={styles.inputWrapper}>
                  <HiOutlineLockClosed color="#454545" />
                  <Input
                    {...field}
                    type="password"
                    onBlur={(e) => {
                      field.onBlur(e);
                      handleBlur(e);
                    }}
                    placeholder="Password"
                    autoComplete="current-password"
                  />
                </div>
              )}
            />
          </Form.Item>

          <Form.Item style={{ alignSelf: "center", width: "100%" }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              className={styles.submitBtn}
            >
              Login Now
            </Button>
          </Form.Item>

          <Form.Item style={{ alignSelf: "stretch" }}>
            <span className={styles.optionsText}>Or Continue with</span>
          </Form.Item>
        </Form>
      )}

      {authType === "login" && loginType === "otp" && (
        <MiniAppOtpLogin setAuthData={setAuthData} navigate={navigateHandler}>
          {/*<GoogleButton onClick={handleLoginWithGoogle} />{" "}*/}
          {/*<span*/}
          {/*  className={styles.createAccountBtn}*/}
          {/*  onClick={() => setAuthType("signup")}*/}
          {/*>*/}
          {/*  Create Account*/}
          {/*</span>*/}
          <div style={{ alignSelf: "stretch" }}>
            <span className={styles.optionsText}>Or Continue with</span>
          </div>
        </MiniAppOtpLogin>
      )}

      {authType === "login" && (
        <>
          <div>
            <span
              className={styles.otpOption}
              onClick={() => {
                if (loginType === "email") {
                  setLoginType("otp");
                } else {
                  setLoginType("email");
                }
              }}
            >
              Login with {loginType === "email" ? "OTP" : "Email/Password"}
            </span>
          </div>
          <div style={{ marginTop: "16px" }}>
            <p
              className={styles.switchToLoginBtn}
              onClick={() => setAuthType("resend-confirmation")}
            >
              Didn't confirm account? <span>Confirm</span>
            </p>
          </div>

          <div
            className={styles.signupOption}
            onClick={() => setAuthType("signup")}
          >
            Don't have an account?
            <span>Sign up</span>
          </div>
        </>
      )}

      {/*{authType === "google" && (*/}
      {/*  <>*/}
      {/*    <FiArrowLeftCircle*/}
      {/*      size={20}*/}
      {/*      className={styles.backBtn}*/}
      {/*      onClick={() => setAuthType("login")}*/}
      {/*    />*/}
      {/*    <MiniAppOtpLogin*/}
      {/*      setAuthData={setAuthData}*/}
      {/*      navigate={navigateHandler}*/}
      {/*      isGoogleLogin={true}*/}
      {/*    />*/}
      {/*  </>*/}
      {/*)}*/}

      <ConfirmAlert
        show={showConfirmAlert}
        setShow={setShowConfirmAlert}
        email={userEmail}
        password={pass}
        telegramId={telegramId}
        navigateHandler={navigateHandler}
      />

      {authType === "signup" && <MiniAppSignupPage setAuthType={setAuthType} />}
      {authType === "confirm" && (
        <MiniAppConfirmPage
          setAuthType={setAuthType}
          navigate={navigateHandler}
        />
      )}
      {authType === "resend-confirmation" && (
        <MiniAppResendConfirmationCode setAuthType={setAuthType} />
      )}

      <RecaptchaModal
        open={showRecaptchaModal}
        onClose={() => {
          setShowRecaptchaModal(false);
          setLoading(false);
        }}
        data={formData}
        useCase="login"
        isMiniApp={true}
      />
    </div>
  );
}

export default MiniAppLoginPage;
